<template>
  <div>
    <ul class="nav nav-pills d-block mb-3">
      <li class="mr-2">
        <a class="nav-link ml-1">
          <i class="fa-fw fas fa-filter" /> <span class="ml-1 font-weight-bold">Filter</span>
        </a>
        <ul class="nav nav-pills">
          <li class="nav-item ml-2">
            <div class="nav-link">
              Fiscal Year
              <b-form-select v-model="fiscalYear">
                <b-form-select-option v-for="year in loadedYears" :key="year" :value="year">
                  {{ year + 1990+1 }}
                </b-form-select-option>
              </b-form-select>
            </div>
            <div class="nav-link">
              Subject
              <b-form-select v-model="subject">
                <b-form-select-option v-for="s in subjects" :key="s" :value="s">
                  {{ s }}
                </b-form-select-option>
              </b-form-select>
            </div>
          </li>
        </ul>
      </li>
    </ul>
    <ul class="nav nav-pills flex-column ml-2 mr-2">
      <li class="nav-item ml-2">
        <router-link class="nav-link" active-class="active" :to="{path: `/HCPT/TGS`}">
          <img src="/Content/icons/guidance.png" class="svg-icon"> Teacher Growth Score Data and Trends
        </router-link>
      </li>
    </ul> 

    <ul class="nav nav-pills flex-column mt-1 mb-3">
      <li class="mr-2">
        <a class="nav-link ml-1">
          <span class="font-weight-bold">Resources</span>
        </a>
        <ul class="nav nav-pills dsubject-block">
          <li class="nav-item ml-2">
            <a href="/content/tgs/Teacher Growth Score Data and Trends Presentation.mp4" active-class="active" class="nav-link">
              <i class="fas fa-fw fa-video mr-1" /> Video Presentation
            </a>
          </li>
        </ul>
        <ul class="nav nav-pills dsubject-block">
          <li class="nav-item ml-2">
            <a href="/content/tgs/Teacher Growth Score Data and Trends Presentation.pptx" active-class="active" class="nav-link">
              <i class="fas fa-fw fa-file-powerpoint mr-1" /> PowerPoint Presentation
            </a>
          </li>
        </ul> 
        <ul class="nav nav-pills dsubject-block">
          <li class="nav-item ml-2">
            <a href="/content/tgs/Teacher Growth Score Data and Trends Presentation FINAL.pdf" active-class="active" class="nav-link">
              <i class="fas fa-fw fa-file-pdf mr-1" /> PDF Presentation
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      lea: null,
    }
  },
  computed: {
    ...mapState('tgsModule', ['loadedYears', 'subject']),
    ...mapState('globalModule', ['userContext']),
    canViewTeacherData() {
      return !(this.userContext.isRecruitment || this.userContext.isTeacherCenter || this.userContext.isSuperintendentCoop)
    },
    subjects() {
      return ['Composite', 'ELA', 'Math', 'Science']
    },
    fiscalYear: {
      set(year) {
        this.$store.commit('tgsModule/setFiscalYear', year)
        // Use push instead of replace to update the query parameter
        // this.$router.push({
        //   query: { 
        //   ...this.$route.query, 
        //   fy: year 
        //   }
        // }).catch(err => {
        //   console.error(err)
        // });
      },
      get() {
        return this.$store.state.tgsModule.fiscalYear
      }
    },
    subject: {
      set(s) {
        this.$store.commit('tgsModule/setSubject', s)
        // Update query parameter when subject changes
        // this.$router.push({
        //   query: { 
        //     ...this.$route.query, 
        //     subject: s 
        //   }
        // })
        // .catch(err => {
        //   console.error(err)
        // });
      },
      get() {
        return this.$store.state.tgsModule.subject
      }
    },
  },
  async created() {    
    if (this.$route.query.fy) {
      // if we have a fy in the query string, use that one
      this.$store.commit('tgsModule/setFiscalYear', this.$route.query.fy)
      console.log('fy from query string', this.$route.query.fy)
    }
    else {
      // else just set to the latest one
      await this.$store.dispatch('tgsModule/getFiscalYears')
      this.fiscalYear = this.loadedYears[0]
    }
    
    // Handle subject from query string
    if (this.$route.query.subject && this.subjects.includes(this.$route.query.subject)) {
      // if we have a subject in the query string, use that one
      this.$store.commit('tgsModule/setSubject', this.$route.query.subject);
      console.log('subject from query string', this.$route.query.subject)
    }
    if (this.$route.query.role) {
      // If you have a role in the store, you can set it here
      this.$store.commit('tgsModule/setRole', this.$route.query.role);
      console.log('role from query string', this.$route.query.role)
    }
  },
  methods: {
    async reloadData() {
      if (this.lea && this.fiscalYear)
      {
        // await this.$store.dispatch('tgsModule/getTeacherTrends', {fiscalYear: this.fiscalYear, lea: this.lea})
        // await this.$store.dispatch('tgsModule/getStateSummary', {fiscalYear: this.fiscalYear})
        // await this.$store.dispatch('tgsModule/getDistrictSummary', {fiscalYear: this.fiscalYear})
        // await this.$store.dispatch('tgsModule/getTeacherVAMData', {lea: this.lea, fiscalYear: this.fiscalYear})
      }
    }
  },
  watch: {
    selectedLea: {
      immediate: true,
      handler(newData) {
        // we are storing the selectedLea's number in lea so we can prevent reloading the data every time the route changes
        if (this.lea != newData.number)
        {
          this.lea = newData.number
          this.reloadData()
        }
      }
    },
    fiscalYear: {
      handler() {
        this.reloadData()
      }
    },
    subject: {
      handler() {
        this.reloadData()
      }
    }
  },
}
</script>
